export const queryNames = {
  CLIENTS: 'clients',
  BALANCE: 'balance',
  PAYMENTS: 'payments',
  USD_AMOUNT: 'usdAmount',
  PAYMENT_HISTORY: 'paymentHistory',
  PROFILE: 'profile',
  CHECK_NEW_VERSION: 'checkNewVersion',
}
